"use client";
import { useContext, useState } from "react";
import EditorLeafDetail from "./EditorLeafDetail";
import ColorName from "./ColorName";
import { icons } from "./icons";
import ColorIcon from "./ColorIcon";
import { deepCopy } from "@/functions/fns";
import { AppContext } from "./AppContext";
import { SortableHandle } from "react-sortable-hoc";
import Button from "./Button";
import LoaderSkeleton from "./LoaderSkeleton";
const DragHandle = SortableHandle(() => {
	const cnt = () => {
		const ret = [];
		for (let m = 0; m < 10; m++) {
			ret.push(
				<div key={m} className="iconColorBg h-[2px] w-[2px]"></div>
			);
		}
		return ret;
	};
	return (
		<div className="mr-1 flex h-10 w-8 cursor-move items-center justify-end pr-3">
			<div className="flex h-[16px] w-[6px] flex-wrap gap-px">
				{cnt()}
			</div>
		</div>
	);
});

export default function EditorLeaf({ ob, idx }) {
	const {
		colorHilight,
		copyColor,
		setCopyColor,
		config,
		setConfig,
		openLeaf,
		setOpenLeaf,
	} = useContext(AppContext);
	const open = openLeaf === idx;

	const delGroup = () => {
		const newConfig = deepCopy(config);
		newConfig.splice(idx, 1);
		setOpenLeaf(null);
		setConfig(newConfig);
	};

	//let cnts = Object.keys(ob).sort()
	const cnts = ["colors", "spread", "x", "y", "blend"];
	const contents = cnts.map((k, i) => (
		<div className="flex items-center justify-between" key={i}>
			<div className="pl-2 capitalize">{k}</div>
			<EditorLeafDetail
				data={ob[k]}
				type={k}
				idx={idx}
				config={config}
				setConfig={setConfig}
			/>
		</div>
	));

	const addStep = () => {
		const newConfig = deepCopy(config);
		if (newConfig[idx].colors.length < 6) {
			const duplicateKeys = ["colors", "spread", "x", "y"];

			duplicateKeys.forEach((k) => {
				newConfig[idx][k].push(
					newConfig[idx][k][newConfig[idx][k].length - 1]
				);
			});

			setConfig(newConfig);
		}
	};

	const [loading, setLoading] = useState(false);
	const preview = () => {
		const { colors } = ob;

		return (
			<div className="relative flex h-12 items-center justify-between gap-2">
				{loading && <LoaderSkeleton />}
				<DragHandle />
				<div className="relative">
					<ColorName
						customLoading={setLoading}
						fallBack={"#" + idx}
						hsla={ob.colors[0]}
					/>
				</div>
				<div className="ml-auto flex items-center gap-1">
					{colors.map((c, i) => {
						const isHilighted =
							colorHilight &&
							colorHilight[0] === idx &&
							colorHilight[1] === i;
						const arr = (
							<div className="scale-50 opacity-40">
								{icons.arrowRight}
							</div>
						);
						return (
							<div key={i} className="flex items-center gap-1">
								<ColorIcon
									isHilighted={isHilighted}
									copyColor={copyColor}
									setCopyColor={setCopyColor}
									config={config}
									setConfig={setConfig}
									arrayIdx={idx}
									idx={i}
									value={c}
								/>
								{arr}
							</div>
						);
					})}
					<div
						className="colorIcon flexer border-color cursor-pointer border dark:bg-dark-800"
						onClick={addStep}
					>
						<div className="scale-50">{icons.plus}</div>
					</div>
				</div>
				<div
					onClick={() => setOpenLeaf(openLeaf === idx ? null : idx)}
					className="flexer mr-2 h-6 w-6 cursor-pointer rounded"
				>
					<div className="scale-50">
						{icons[!open ? "arrowDown" : "arrowUp"]}
					</div>
				</div>
			</div>
		);
	};

	return (
		<div className="colorItem relative z-[99999999] flex flex-1 items-center gap-2 overflow-hidden">
			<div className="flex flex-1 flex-col justify-center">
				{preview()}
				{open && (
					<div className="divide-color flex flex-col divide-y">
						<div className="divide-color border-color flex flex-col divide-y border-t">
							{contents}
							<div className="flex p-2">
								<Button
									className="border border-red-500/30 px-3 text-red-400 hover:bg-red-500/10 "
									onClick={delGroup}
								>
									Delete
								</Button>
							</div>
						</div>
					</div>
				)}
			</div>
		</div>
	);
}
